module.exports = __webpack_public_path__ + "static/media/icon-file-img.28f07897.svg";